import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import DocumentType from "../../../Models/Catalogue/Generic/DocumentType";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class DocumentTypeCatalogueEntry extends CatalogueEntry<DocumentType> {

    constructor() {
        super("Document Types", DocumentType);
    }

    public get editRole() {
        return CatalogueRoles.DocumentTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.documentTypes;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveDocumentTypes;
    }
    
    public renderRow(item: DocumentType, meta: Model.TransformMetaType<DocumentType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.documentTypeName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}